<div class="container container-main">
  <app-reports-general-header />
  <div class="card border-0 p-3">
    <app-reporting-subnav></app-reporting-subnav>
    <div class="card-body">
      <h2 class="fw-bolder text-center mb-4">Event Summary</h2>

      <div class="d-flex justify-content-end">
        <button
          ngbTooltip="Download CSV"
          aria-label="Download CSV"
          class="btn"
          container="body"
          placement="bottom"
          [autoClose]="false"
          [ngbPopover]="csvDownloadingPopover"
          [disabled]="disableDownload"
          (click)="downloadCSV()"
          #p="ngbPopover">
          <i [ngClass]="['bi', 'fs-21', 'bi-download']"></i>
        </button>
        <ng-template #csvDownloadingPopover>
          <div class="p-2">
            Your report is generating. The download will begin shortly.
          </div>
          <div class="p-2 d-flex justify-content-center">
            <button
              type="button"
              class="btn btn-primary btn-sm"
              (click)="p.close()">
              OK
            </button>
          </div>
        </ng-template>
      </div>

      <app-report-filter-bar
        [canFilterByDistrict]="canFilterByDistrict"
        [reportName]="'pd_session_summary'"></app-report-filter-bar>
      <ng-container *ngIf="!pdSessionId">
        <div class="card border-0 table-container">
          <table class="table">
            <thead>
              <tr class="align-middle">
                <th
                  scope="col"
                  (sort)="onSort($event)"
                  sortable="session_name"
                  class="sortable-header"
                  style="min-width: 250px">
                  Event Name
                  <i
                    class="bi bi-caret-down {{
                      sortIconTemp.session_name
                    }}"></i>
                </th>
                <th
                  scope="col"
                  (sort)="onSort($event)"
                  sortable="session_date"
                  class="sortable-header"
                  style="min-width: 220px">
                  Event Date
                  <i
                    class="bi bi-caret-down {{
                      sortIconTemp.session_date
                    }}"></i>
                </th>
                <th
                  scope="col"
                  (sort)="onSort($event)"
                  sortable="facilitators"
                  class="sortable-header"
                  style="min-width: 200px">
                  Facilitators
                  <i
                    class="bi bi-caret-down {{
                      sortIconTemp.facilitators
                    }}"></i>
                </th>

                <th
                  scope="col"
                  (sort)="onSort($event)"
                  sortable="session_type"
                  class="sortable-header"
                  style="min-width: 150px">
                  Event Type
                  <i
                    class="bi bi-caret-down {{
                      sortIconTemp.session_type
                    }}"></i>
                </th>
                <th
                  scope="col"
                  (sort)="onSort($event)"
                  sortable="registered_count"
                  class="sortable-header"
                  style="min-width: 150px">
                  # Registered
                  <i
                    class="bi bi-caret-down {{
                      sortIconTemp.registered_count
                    }}"></i>
                </th>
                <th
                  scope="col"
                  (sort)="onSort($event)"
                  sortable="attended_count"
                  class="sortable-header"
                  style="min-width: 150px">
                  # Attended
                  <i
                    class="bi bi-caret-down {{
                      sortIconTemp.attended_count
                    }}"></i>
                </th>
                <th
                  scope="col"
                  (sort)="onSort($event)"
                  sortable="waitlist_count"
                  class="sortable-header"
                  style="min-width: 150px">
                  # On Waitlist
                  <i
                    class="bi bi-caret-down {{
                      sortIconTemp.waitlist_count
                    }}"></i>
                </th>
                <th
                  scope="col"
                  (sort)="onSort($event)"
                  sortable="percent_present"
                  class="sortable-header"
                  style="min-width: 150px">
                  % Present
                  <i
                    class="bi bi-caret-down {{
                      sortIconTemp.percent_present
                    }}"></i>
                </th>
                <th
                  scope="col"
                  (sort)="onSort($event)"
                  sortable="is_completed"
                  class="sortable-header"
                  style="min-width: 150px">
                  Is Completed
                  <i
                    class="bi bi-caret-down {{
                      sortIconTemp.is_completed
                    }}"></i>
                </th>

                <th
                  scope="col"
                  (sort)="onSort($event)"
                  sortable="competencies"
                  class="sortable-header"
                  style="min-width: 220px">
                  Competencies
                  <i
                    class="bi bi-caret-down {{
                      sortIconTemp.competencies
                    }}"></i>
                </th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="!isLoading; else loadingTemplate">
                <ng-container *ngIf="tableData?.length; else noTableData">
                  <tr *ngFor="let item of tableData" class="align-middle">
                    <td>
                      <a
                        (click)="selectSession(item.pdSessionId)"
                        class="cursor-pointer fw-bold"
                        >{{ item.sessionName }}</a
                      >
                    </td>
                    <td class="text-center">
                      {{ item.sessionDate }}
                    </td>
                    <td>
                      <div *ngFor="let facilitator of item.facilitators">
                        <div
                          *ngIf="facilitator"
                          class="d-flex flex-nowrap align-items-center my-2">
                          <app-avatar
                            [profile]="facilitator.profile"
                            [avatarSize]="'small'"></app-avatar>
                          <div class="fw-light ms-2">
                            {{ facilitator.profile.first_name }}
                            {{ facilitator.profile.last_name }}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      {{ item.sessionType }}
                    </td>
                    <td class="text-center">
                      {{ item.registeredCount }}
                    </td>
                    <td class="text-center">
                      {{ item.attendedCount }}
                    </td>
                    <td class="text-center">
                      {{ item.waitlistCount }}
                    </td>
                    <td class="text-center">{{ item.percentPresent }}%</td>
                    <td class="text-center">
                      <i
                        *ngIf="item.isCompleted"
                        class="bi bi-check2-circle text-info"></i>
                      <i
                        *ngIf="!item.isCompleted"
                        class="bi bi-circle-fill"></i>
                    </td>
                    <td class="text-center">
                      <span
                        *ngFor="let competency of item.competencies"
                        class="badge badge-item me-1"
                        title="{{ competency }}">
                        {{ competency }}
                      </span>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
            </tbody>
            <ng-template #loadingTemplate>
              <div class="loader-container">
                <app-loader></app-loader>
              </div>
            </ng-template>
          </table>
          <ng-template #noTableData>
            <tr>
              <td></td>
              <td></td>
              <td>
                <p class="text-center my-5">No Events Found.</p>
              </td>
            </tr>
          </ng-template>
        </div>
        <section>
          <div class="d-flex justify-content-center mt-4">
            <ngb-pagination
              *ngIf="listMeta && listMeta.totalCount > 10"
              [(page)]="listMeta.currentPage"
              [pageSize]="listMeta.perPage"
              [collectionSize]="listMeta.totalCount"
              [maxSize]="5"
              (pageChange)="paginationChange()"></ngb-pagination>
          </div>
        </section>
      </ng-container>
      <ng-container *ngIf="pdSessionId">
        <div class="card border-0 table-container">
          <div
            class="d-flex justify-content-between align-items-center mb-2"
            *ngIf="this.sessionNameShortened">
            <h5 class="mb-0">Event: {{ this.sessionNameShortened }}</h5>
            <a
              (click)="backToSessionSummary()"
              class="text-decoration-none cursor-pointer fs-18 d-flex align-items-center"
              style="color: #000"
              >Back <i class="bi bi-arrow-return-left bold-icon ms-1"></i
            ></a>
          </div>
          <table class="table">
            <thead>
              <tr class="align-middle">
                <th
                  scope="col"
                  (sort)="onSort($event)"
                  sortable="user_name"
                  class="sortable-header"
                  style="min-width: 250px">
                  User Name
                  <i
                    class="bi bi-caret-down {{
                      sortIconTempDrilldown.user_name
                    }}"></i>
                </th>
                <th
                  scope="col"
                  (sort)="onSort($event)"
                  sortable="school"
                  class="sortable-header"
                  style="min-width: 220px">
                  School
                  <i
                    class="bi bi-caret-down {{
                      sortIconTempDrilldown.school
                    }}"></i>
                </th>
                <th
                  scope="col"
                  (sort)="onSort($event)"
                  sortable="cohorts"
                  class="sortable-header"
                  style="min-width: 200px">
                  Cohorts
                  <i
                    class="bi bi-caret-down {{
                      sortIconTempDrilldown.cohorts
                    }}"></i>
                </th>
                <th
                  scope="col"
                  (sort)="onSort($event)"
                  sortable="status"
                  class="sortable-header"
                  style="min-width: 150px">
                  Status
                  <i
                    class="bi bi-caret-down {{
                      sortIconTempDrilldown.status
                    }}"></i>
                </th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="!drilldownIsLoading; else loadingTemplate">
                <ng-container *ngIf="drillDownTableData; else noTableData">
                  <tr
                    *ngFor="let item of drillDownTableData"
                    class="align-middle">
                    <td>
                      <a
                        href="/training/transcript/{{ item.userId }}"
                        target="_blank"
                        >{{ item.userName }}</a
                      >
                    </td>
                    <td class="text-center">
                      {{ item.school }}
                    </td>
                    <td class="text-center">
                      <span
                        *ngFor="let cohort of item.cohorts"
                        class="badge badge-item me-1"
                        title="{{ cohort }}">
                        {{ cohort }}
                      </span>
                    </td>
                    <td class="text-center">
                      {{ item.status }}
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
            </tbody>
            <ng-template #loadingTemplate>
              <div class="loader-container">
                <app-loader></app-loader>
              </div>
            </ng-template>
          </table>
          <ng-template #noTableData>
            <tr>
              <td></td>
              <td></td>
              <td>
                <p class="text-center my-5">No Events Found.</p>
              </td>
            </tr>
          </ng-template>
        </div>
        <section>
          <div class="d-flex justify-content-center mt-4">
            <ngb-pagination
              *ngIf="listMeta && listMeta.totalCount > 10"
              [(page)]="listMeta.currentPage"
              [pageSize]="listMeta.perPage"
              [collectionSize]="listMeta.totalCount"
              [maxSize]="5"
              (pageChange)="paginationChange()"></ngb-pagination>
          </div>
        </section>
      </ng-container>
    </div>
    <div class="mt-5 text-muted small text-end">
      Data last refreshed at {{ lastUpdatedDate }}
    </div>
  </div>
</div>
